import { BanknotesIcon, BuildingOfficeIcon, CreditCardIcon, UserIcon } from '@heroicons/react/20/solid';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { TwContainer, TwMainLayout, TwTabContainer } from '../../../components/tailwind';
import { useLocalStorage } from "../../../hooks";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { clearLoadingData, setActionLoading } from '../../../redux/reducers/loadingReducer';
import * as userActions from "../../../redux/reducers/userReducer";
import { userState } from "../../../redux/reducers/userReducer";
import axiosInstance from '../../../utils/axiosInstance';
import { getUrlForUsers } from '../../../utils/confighelpers';
import BusinessPaymentProfile from '../../paymentProfile/BusinessPaymentProfile';
import EditBusinessProfile from "../businessProfile/EditBusinessProfile";
import ProfileForm from "../myProfile/ProfileForm";
import MyBilling from './billing/MyBilling';
import { useTranslation } from 'react-i18next';

const MyAccount = ({ navigation, title, selectedTab }) => {

  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const defaultAvatarData = "https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png";
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");

  useEffect(() => {
    dispatch(clearLoadingData());
    (async () => {
      const userrequest = await axiosInstance({
        method: "get",
        // url: `${getUrlForStage()}schools/mySchoolList`,
        url: `${getUrlForUsers()}getUserInfo`,
      });
      if (userrequest.data.statusCode === 200) {
        dispatch(userActions.setUserData({
          // ...userReduxState.userData,
          appUrl: userReduxState.userData.appUrl,
          ...userrequest.data.data,
        }));
      }
    })();
    return () => {
      dispatch(setActionLoading(false));
    }
  }, [])

  return (
    <TwMainLayout
      headTitle={t("pageTitle.accountSettings")}
      // ]}
      children={
        <TwContainer className="md:!px-0 py-0">
          <TwTabContainer
            className=""
            tabsClassName="border-b px-5 md:px-10"
            selectedTab={selectedTab}
            tabs={[
              {
                name: t("account.account"), key: 'account', onClick: () => { }, icon: UserIcon,
                tabPanelComponent: (
                  <div className="">
                    <ProfileForm />
                  </div>
                )
              },
              {
                name: t("account.organization"), key: 'organization', onClick: () => { }, icon: BuildingOfficeIcon,
                tabPanelComponent: (
                  <div className="">
                    <EditBusinessProfile navigation={navigate} />
                  </div>
                )
              },
              {
                name: t("account.onlinePayment"), key: 'online-payment', onClick: () => { }, icon: BanknotesIcon,
                tabPanelComponent: (
                  <div className="">
                    <BusinessPaymentProfile navigation={navigate} screenView="tab" selectedTab="online-payment" title="Online Payment" />
                  </div>
                )
              },
              {
                name: t("account.billing"), onClick: () => { }, icon: CreditCardIcon,
                tabPanelComponent: (
                  <div className="">
                    <MyBilling navigation={navigate} />
                  </div>
                )
              },

            ]}
          />
        </TwContainer>
      } />
  );
};

export default MyAccount;
